import React, { useCallback, useEffect, useState } from 'react';
import { ModalDialog } from '../../../common/Dialogs';
import { SpacingContainer } from '../../../common/Containers/Base';
import Typography from '../../../common/Typography';
import { Button } from '../../../common/Buttons';
import SetPhone from '../../../../containers/Profile/PhoneNumber/SetPhone';
import { useTrans } from '../../../../services/i18n';
import { useApplication } from '../../../../services/application';
import { useAlertContext } from '../../../../contexts/AlertContext';
import { shouldShowPhonePrompt } from '../../../../utils/phonePrompt';
import connect from './connect';

const FirstLoginPhoneModal = ({ authUser, update }) => {
  const { trans } = useTrans();
  const application = useApplication();
  const { errorAlert } = useAlertContext();
  const [open, setOpen] = useState(false);
  const [skipPending, setSkipPending] = useState(false);

  useEffect(() => {
    setOpen(shouldShowPhonePrompt(authUser));
  }, [authUser]);

  const handleSkip = useCallback(async () => {
    setSkipPending(true);
    try {
      const res = await application.call('user.skipPhonePrompt', {});
      if (res?.success) {
        const phonePromptSkippedAt = res.phonePromptSkippedAt || Math.floor(Date.now() / 1000);
        update({ phonePromptSkippedAt });
        setOpen(false);
      } else {
        errorAlert(res?.error || trans('api-error'));
      }
    } catch (e) {
      errorAlert(e.message);
    } finally {
      setSkipPending(false);
    }
  }, [application, update, errorAlert, trans]);

  const handleVerifiedClose = useCallback(() => {
    setOpen(false);
  }, []);

  if (!open) {
    return null;
  }

  return (
    <ModalDialog
      open={open}
      onClose={handleSkip}
      disableEscapeKeyDown
      disableBackdropClick
      title={
        <Typography weight={'500'} fontFamily="lexend" style={{ fontSize: '1.313rem' }}>
          {trans('add-phone')}
        </Typography>
      }
    >
      <SpacingContainer py={0}>
        <SetPhone auth={authUser} onClose={handleVerifiedClose} />
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Button variant="text" color="primary" onClick={handleSkip} pending={skipPending} disabled={skipPending}>
            {trans('skip-for-now')}
          </Button>
        </div>
      </SpacingContainer>
    </ModalDialog>
  );
};

export default connect(FirstLoginPhoneModal);
